<section class="properties-page">

  <!-- Page header -->
  <header class="page-header">
    <div class="page-header__title">
      <span class="page-header__icon">
        <mat-icon aria-hidden="true" svgIcon="new-house"></mat-icon>
      </span>
      <div>
        <h1>Your properties</h1>
        <p class="page-header__subtitle">Manage the rental properties registered to your account</p>
      </div>
    </div>

    <div class="stat-chip" aria-label="Total properties">
      <span class="stat-chip__value">{{ dataSource.data.length }}</span>
      <span class="stat-chip__label">Total</span>
    </div>
  </header>

  <!-- Toolbar -->
  <div class="toolbar">
    <!-- Mobile-only trigger: opens the search/filter bottom sheet -->
    <button type="button" class="toolbar__filter-trigger" (click)="openMobileFilters()">
      <mat-icon>tune</mat-icon>
      <span>Search &amp; filters</span>
      <span class="toolbar__filter-badge" *ngIf="activeFilterCount">{{ activeFilterCount }}</span>
    </button>

    <!-- Filters: inline on desktop, bottom-sheet modal on mobile -->
    <div class="toolbar__filters" [class.is-open]="mobileFiltersOpen">
      <div class="toolbar__backdrop" (click)="closeMobileFilters()"></div>

      <div class="toolbar__sheet" role="dialog" aria-label="Search and filters">
        <div class="toolbar__sheet-header">
          <span>Search &amp; filters</span>
          <button type="button" mat-icon-button (click)="closeMobileFilters()" aria-label="Close filters">
            <mat-icon>close</mat-icon>
          </button>
        </div>

        <mat-form-field class="toolbar__search" appearance="outline" subscriptSizing="dynamic">
          <mat-label>Search by property ID or address</mat-label>
          <input matInput (keyup)="applyFilter()" [(ngModel)]="filters.searchTerm"
                 placeholder="Type to find a property">
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>

        <mat-form-field class="toolbar__field" appearance="outline" subscriptSizing="dynamic">
          <mat-label>Status</mat-label>
          <mat-select [(ngModel)]="filters.status" (selectionChange)="applyFilter()" placeholder="Status">
            <mat-option value="">All</mat-option>
            <mat-option value="1">Active</mat-option>
            <mat-option value="2">Inactive</mat-option>
            <mat-option value="3">Closed</mat-option>
            <mat-option value="4">Living in Home</mat-option>
            <mat-option value="5">Suspect</mat-option>
            <mat-option value="6">Suspect Inactive</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field *ngIf="externalUser?.accountType == 2" class="toolbar__field" appearance="outline" subscriptSizing="dynamic">
          <mat-label>Owner</mat-label>
          <mat-select [(ngModel)]="filters.owner" (selectionChange)="applyFilter()" placeholder="Owner">
            <mat-option value="">All</mat-option>
            @for (owner of propertyOwners; track owner.id) {
              <mat-option [value]="owner.id">{{ owner.firstName }} {{ owner.lastName }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <button type="button" class="toolbar__sheet-done" (click)="closeMobileFilters()">Done</button>
      </div>
    </div>

    <span class="toolbar__spacer"></span>

    <button mat-flat-button color="primary" class="toolbar__add"
            [routerLink]="['/app/addNewProperty']" routerLinkActive="active">
      <mat-icon>add</mat-icon>
      Add property
    </button>
  </div>

  <!-- Table card -->
  <div class="table-card">

    @if (loading) {
      <div class="state state--loading">
        <mat-spinner diameter="40"></mat-spinner>
        <p>Loading your properties…</p>
      </div>
    } @else {
      <div class="table-scroll">
        <table mat-table [dataSource]="dataSource" matSort class="properties-table">

          <ng-container matColumnDef="propertyId">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>Property ID</th>
            <td mat-cell *matCellDef="let element" data-label="Property ID">
              <span class="cell-id">{{ element.propertyId }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="streetAddress">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>Street address</th>
            <td mat-cell *matCellDef="let element" data-label="Street address">{{ element.streetAddress }}</td>
          </ng-container>

          <ng-container matColumnDef="type">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>Property type</th>
            <td mat-cell *matCellDef="let element" data-label="Property type">{{ element.typeDescription }}</td>
          </ng-container>

          <ng-container *ngIf="externalUser?.accountType == 2" matColumnDef="ownerName">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>Owner</th>
            <td mat-cell *matCellDef="let element" data-label="Owner">{{ element.ownerName }}</td>
          </ng-container>

          <ng-container *ngIf="externalUser?.accountType != 2" matColumnDef="lastPayment">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>Last payment</th>
            <td mat-cell *matCellDef="let element" data-label="Last payment">{{ element.lastPayment || "—" }}</td>
          </ng-container>

          <ng-container matColumnDef="statusDescription">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let element" data-label="Status">
              <app-property-status [statusDescription]="element.statusDescription"
                                   [rentaPropertyStatus]="element.status"></app-property-status>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row class="property-row" (click)="onRowClick(row)"
              *matRowDef="let row; columns: displayedColumns;"></tr>

          <!-- No results within current filter -->
          <tr class="mat-row" *matNoDataRow>
            <td class="state state--empty" [attr.colspan]="displayedColumns.length">
              <mat-icon>home_work</mat-icon>
              <p class="state__title">No properties found</p>
              <p class="state__hint">Try adjusting your search or filters, or add a new property.</p>
            </td>
          </tr>
        </table>
      </div>

      <mat-paginator [pageSizeOptions]="[10, 25, 100]" showFirstLastButtons
                     aria-label="Select page of properties"></mat-paginator>
    }
  </div>
</section>
